import { FormControl, styled } from '@mui/material';

const FormControlWithMargin = styled(FormControl)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export default FormControlWithMargin;
